import "../0.styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import { Box, Button, Container, Grid, IconButton } from "@mui/material";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import { AlertDialog } from "../Components/AlertDialog";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  deleteTableDots,
  functions,
  instance,
  validateFunction,
} from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { useMemo, useState } from "react";
import { LoaderBox } from "../Components/LoaderBox";

function Unidades() {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
  });
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [alertDialog, setAlertDialog] = useState({
    title: "",
    text: "",
  });
  const [item, setItem] = useState({ type: "", id: "", activo: "" });
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  deleteTableDots(2);
  const navigate = useNavigate();
  function editUnidad(id) {
    console.log(`/UnidadEditar id: ${id}`);
    navigate("/UnidadEditar", {
      state: {
        id: id,
      },
    });
  }

  const yesClick = () => {
    handleToggle();
    setOpenAlertDialog(false);
  };
  const noClick = () => {
    setOpenAlertDialog(false);
  };

  const disableItem = (id, nombre, activo) => {
    setItem({ id: id, activo: activo });
    setAlertDialog({
      title: "Alerta",
      text: `¿Seguro que deseas ${
        activo ? "deshabilitar" : "habilitar"
      } la unidad: ${nombre}?`,
    });
    setOpenAlertDialog(true);
  };
  const columns = useMemo(() => [
    {
      accessorKey: "categoria",
      header: "Categoría",
    },
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "nombre",
      header: "Nombre",
      size: 50,
    },
    {
      accessorKey: "activo",
      header: "Activo",
    },
    {
      accessorFn: (row) => `edit`,
      id: "edit",
      header: "",
      size: 50,
      enableColumnFilter: false,
      Cell: ({ renderedCellValue, row }) =>
        validateFunction(user, functions.ModifyProduct) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Button
              onClick={() => {
                navigate("/UnidadEditar", {
                  state: {
                    id: row.original.id,
                  },
                });
              }}
            >
              <EditTwoToneIcon />
              Editar
            </Button>
          </Box>
        ),
    },
    {
      accessorFn: (row) => `toggle`,
      id: "toggle",
      header: "",
      size: 50,
      disableColumnMenu: true,
      Cell: ({ renderedCellValue, row }) =>
        validateFunction(user, functions.ToggleProductState) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Button
              onClick={() =>
                disableItem(
                  row.original.id,
                  row.original.nombre,
                  row.original.activo
                )
              }
              color={row.original.activo ? "error" : "success"}
            >
              {row.original.activo ? "Deshabilitar" : "Habilitar"}
            </Button>
          </Box>
        ),
    },
  ]);
  function populateTable() {
    instance
      .get("/unidad/listAll/")
      .then((res) => {
        setItems(res.data);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      });
  }
  if (isLoading) {
    populateTable();
    setLoading(false);
  }

  const handleToggle = () => {
    instance
      .patch(`/unidad/toggleActivate`, {
        user: user.id,
        id: item.id,
        activo: item.activo,
      })
      .then((res) => {
        setDialog({
          title: "Aviso",
          text: `Se ha actualizado correctamente el estado de la unidad`,
        });
        setOpenDialog(true);
        populateTable();
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxwidth="xl"
        sx={{
          marginTop: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <Grid container gap={{ xs: "0px", sm: "12px" }}>
            <Grid item xs={12} sm={12} md={12}>
              <MaterialReactTable
                localization={MRT_Localization_ES}
                columns={columns}
                data={items}
                enableColumnFilterModes={false}
                enableColumnOrdering={false}
                enableGrouping={false}
                enablePinning={false}
                enableRowActions={false}
                initialState={{
                  pagination: { pageSize: 5 },
                  showColumnFilters: false,
                  columnVisibility: {
                    id: false,
                    activo: false,
                    edit: validateFunction(user, functions.ModifyProduct),
                    toggle: validateFunction(
                      user,
                      functions.ToggleProductState
                    ),
                  },
                }}
                positionToolbarAlertBanner="none"
                enableColumnFilters={false}
                enableGlobalFilter={true}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enablePagination={true}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                renderTopToolbarCustomActions={({ table }) => (
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    {validateFunction(user, functions.CreateUnit) && (
                      <IconButton
                        color="success"
                        onClick={() => {
                          navigate("/UnidadAgregar");
                        }}
                        variant="contained"
                      >
                        <AddCircleTwoToneIcon />
                        <p className="IconButtonText">Agregar</p>
                      </IconButton>
                    )}
                  </Box>
                )}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
      <AlertDialog
        open={openAlertDialog}
        accept={yesClick}
        acceptText={"Aceptar"}
        decline={noClick}
        declineText={"Cancelar"}
        title={alertDialog.title}
        text={alertDialog.text}
      />
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { Unidades };
